import { addLocaleData } from 'react-intl';
import FaLang from './entries/fa-IR';

const AppLocale = {
    fa: FaLang,
};
addLocaleData(AppLocale.fa.data);

export default AppLocale;
